import { useFormContext } from 'dynamic-uniforms'
import { createContext, ReactNode, useContext } from 'react'

export const CiboAutoFormContext = createContext<{
  renderDisplay?: (config: { field: any; itemProps: any }) => ReactNode
}>({})

export const useCiboAutoForm = () => {
  const form = useFormContext()
  const context = useContext(CiboAutoFormContext)

  return { ...form, ...context, error: form.errors, schema: form.bridge }
}
